import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { ContentRecommendations } from "pages/admin/experiments/ContentRecommendations";
import { CropDetection } from "pages/admin/experiments/CropDetection";
import { CropDetectionRD } from "pages/admin/experiments/CropDetectionRD";
import { Delineation } from "pages/admin/experiments/Delineation";
import { Visualisations } from "pages/admin/experiments/Visualisations";

export const SoilAI = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Crop detection",
      key: "detection",
      component: <CropDetection />,
    },
    {
      name: "Crop visualisations",
      key: "visualisations",
      component: <Visualisations />,
    },
    {
      name: "Content recommendations",
      key: "recommendations",
      component: <ContentRecommendations />,
    },
    {
      name: "Field delineation",
      key: "delineation",
      component: <Delineation />,
    },
    {
      name: "R&D Crop Detection",
      key: "rand",
      component: <CropDetectionRD />,
    },
    {
      name: "Yield predictions",
      key: "yield-predictions",
      component: <></>,
    },
    {
      name: "Crop recommendations",
      key: "crop-recommendations",
      component: <></>,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user.role, `soilai/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
          disabled: true,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/soilai/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
